// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__fj_aN","rootCenter":"LoadMoreObserver_rootCenter__1hpzH","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__jKtJ1"};